import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { Box, Container, Divider, Grid, Typography } from '@mui/material';
import Accordion from '@mui/material/Accordion';
import AccordionDetails from '@mui/material/AccordionDetails';
import AccordionSummary from '@mui/material/AccordionSummary';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import { makeStyles } from '@mui/styles';

import KenFieldContent from './Components/KenFieldContent';

const useStyles = makeStyles((theme) => ({
  sectionLabel: {
    // color: theme.palette.primary.main,
    fontWeight: 600,
    fontFamily: 'GeneralSans',
  },
}));

const SectionContent = ({ fields = [] }) => {
  return (
    <Grid container spacing={4} rowSpacing={2}>
      {fields.map((field) => (
        <KenFieldContent {...field} />
      ))}
    </Grid>
  );
};

export default function Section(props) {
  const { sectionName, subSectionName, sectionId, fields, isLast, sectionHelp } = props;
  const theme = useTheme();
  const isMobileScreen = useMediaQuery(theme.breakpoints.down('sm'));
  const classes = useStyles();

  return (
    <>
      <Container
        sx={{
          maxWidth: '1300px !important',
        }}
      >
        {isMobileScreen ? (
          <Box component={"div"}>
            {sectionHelp && (
              <Typography component={'h6'} margin={"20px 0px"} color={'#8A8A8A'} variant={isMobileScreen ? "extrasmallthin" : "smallmedium"}>
                {sectionHelp}
              </Typography>
            )}
            <Box key={sectionId}>
              <SectionContent fields={fields} />
            </Box>
          </Box>
        ) : (
          <>
            <Box component={'div'} className="mt-3 mb-5 d-flex align-items-center justify-content-between">
              <Box component={'div'} className="d-flex flex-column" gap={'12px'}>
                {sectionName && (
                  <Typography component={'h6'} color={'#333333'} variant="largemedium">
                    {sectionName}
                  </Typography>
                )}
                {subSectionName && (
                  <Typography align="left" marginBottom={theme.spacing(4)} className={classes.sectionSubLabel} variant="body2">
                    {subSectionName}
                  </Typography>
                )}
              </Box>
              {sectionHelp && (
                <Typography component={'h6'} color={'#8A8A8A'} variant="smallmedium">
                  {sectionHelp}
                </Typography>
              )}
            </Box>
            <Box key={sectionId}>
              <SectionContent fields={fields} />
            </Box>
            {!isLast && (
              <Divider
                style={{
                  margin: `${theme.spacing(3)} auto`,
                }}
              />
            )}
          </>
        )}
      </Container>
    </>
  );
}
